// @flow @format
import React from 'react';
import {connect} from 'react-redux';
import DownloadProgressContainer from '../../containers/DownloadProgressContainer';
import Footer from '../../../../components/Footer';
import {
	DOWNLOAD_COMPLETED_STATUS,
	DOWNLOAD_FAILED_STATUS,
} from 'lib/downloader';

import type {State} from '../../../../reducers';

type Props = {
	visible: boolean,
};

const FilesFooter = ({visible}: Props) =>
	<Footer visible={visible}>
		<DownloadProgressContainer />
	</Footer>;

const mapStateToProps = (state: State) => {
	let visible = false;

	const downloads = state.entities.downloads.entities;
	for (const id in downloads) {
		if (downloads.hasOwnProperty(id)) {
			const download = downloads[id];

			if (
				download.status !== DOWNLOAD_FAILED_STATUS &&
				download.status !== DOWNLOAD_COMPLETED_STATUS
			) {
				visible = true;
				break;
			}
		}
	}

	return {visible: visible};
};

export default connect(mapStateToProps)(FilesFooter);



// WEBPACK FOOTER //
// ./src/routes/Explorer/components/Footer/index.js